/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Auth_Error_User_Not_FoundInputs */

const es_login_auth_error_user_not_found = /** @type {(inputs: Login_Auth_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró una cuenta asociada a ese proveedor.`)
};

const en_login_auth_error_user_not_found = /** @type {(inputs: Login_Auth_Error_User_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account was found associated with that provider.`)
};

/**
* | output |
* | --- |
* | "No account was found associated with that provider." |
*
* @param {Login_Auth_Error_User_Not_FoundInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_auth_error_user_not_found = /** @type {((inputs?: Login_Auth_Error_User_Not_FoundInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Auth_Error_User_Not_FoundInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_auth_error_user_not_found(inputs)
	return en_login_auth_error_user_not_found(inputs)
});
export { login_auth_error_user_not_found as "login.auth_error.user_not_found" }